module.exports = __webpack_public_path__ + "img/speed_norms_img.ee26582f.png";